function getApplicationType(app: string) {
  const applications = {
    quote: "Quote",
    renewal: "Renewal",
  };

  const application: "quote" | "renewal" =
    (app as "quote" | "renewal") ?? "quote";

  return applications[application];
}

export default getApplicationType;
